module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-09.8d92e62e.jpg";